import type { Messages } from '../types';

export const hub = {
  back: 'Kembali',
  activity: 'Aktiviti',
  report: 'Laporan',
  generate: 'Jana',
  generateFirstReport: 'Jana laporan pertama',
  generateFirstReportBody:
    'Lihat kemajuan {childName} dirumuskan dalam bahasa mudah, berserta apa yang perlu dilatih seterusnya.',
  generateReport: 'Jana laporan',
  viewAllReports: 'Lihat semua laporan',
  homework: 'Kerja rumah',
  nothingAssigned: 'Tiada kerja rumah diberi lagi',
  viewAllHomework: 'Lihat semua kerja rumah',
  assignHint: 'Beri kerja rumah daripada cadangan dalam laporan, atau daripada Latihan.',
  unlink: 'Putuskan hubungan dengan {childName}',
  reportMeta: '{date} · ketepatan {accuracy}%',
  syllabusHeading: 'Sukatan Pelajaran',
  syllabusStudentControlled:
    '{childName} memilihnya sendiri dalam apl mereka, daripada apa yang pelan anda liputi.',
  syllabusNotSet: 'Belum ditetapkan',

  noReports: 'Tiada laporan lagi',
  noReportsBody: 'Jana laporan pertama dari halaman anak untuk melihatnya di sini.',
  reportListMeta: '{date} · {period} · {accuracy}%',

  allReports: 'Semua laporan',
  allHomework: 'Semua kerja rumah',

  noActivity: 'Tiada aktiviti lagi',
  noActivityBody: 'Sesi latihan dan kerja rumah yang selesai akan dipaparkan di sini.',
  practiceSession: 'Sesi latihan',
  actFinishedHomework: 'Siap kerja rumah: {chapter} · {correct}/{total} betul',
  actPractised: 'Berlatih {chapter} · {correct}/{total} betul',
  actLeftUnfinished: 'Berlatih {chapter} · tidak diselesaikan',
  showMore: 'Tunjuk lagi',
  activityCapNote: 'Memaparkan 20 catatan terkini',

  reportFallbackTitle: 'Laporan {childName}',
  downloaded: 'Dimuat turun',
  downloadPdf: 'Muat turun PDF',
  share: 'Kongsi',

  cancel: 'Batal',
  generatingSummary: 'Menjana ringkasan {childName}',
  summaryFallbackName: 'Ringkasan',
  generatingStep0: 'Tupai sedang menganalisis kemajuan pembelajaran matematik...',
  generatingStep1: 'Menyusun cadangan yang disesuaikan...',
  childNotFound: 'Anak tidak ditemui',
  childNotFoundBody: 'Hubungan ini mungkin telah dibuang. Kembali ke senarai anak anda.',
  backToChildren: 'Kembali ke Anak',
  couldNotLoadReport: 'Tidak dapat memuatkan laporan ini',
  retry: 'Cuba lagi',
  refreshNote:
    'Ringkasan dikemas kini sekali sehari, dan hanya apabila ada kemajuan baharu sejak laporan terakhir.',
  toastCooldown: 'Anda boleh menjana semula esok — memaparkan laporan terkini.',
  toastNoChanges: 'Tiada aktiviti baharu lagi — memaparkan laporan terkini.',

  homeworkFallbackTitle: 'Kerja rumah',
  subLineBase: 'Kerja rumah · {studentName}',
  subLineDone: 'Siap {date}, {time}',
  subLineStarted: 'Dimulakan {date}',
  notStarted: 'Belum dimulakan',
  notStartedBody: 'Kerja rumah ini belum dimulakan.',
  correctSuffix: 'betul',
  finishedIn: 'siap dalam {minutes} minit',
  answered: 'Dijawab {answer}',
  correctAnswerIs: 'Jawapan betul {answer}',
  detailUnavailable: 'Butiran tidak tersedia',
  allQuestionsListed: 'kesemua {total} soalan disenaraikan',

  appUsagePeriod: 'Penggunaan apl · tempoh laporan',
  appUsageTwoWeeks: 'Penggunaan apl · 2 minggu terkini',
  daysOf: '{active} daripada {total} hari',
  studyTime: 'Masa belajar',
  dailyAverage: 'Purata harian',
  minsShort: '{mins} min',
  hoursMins: '{hours}j {mins}m',
  minsTooltip: '{mins} minit',
  periodStart: 'Mula tempoh',
  periodEnd: 'Akhir tempoh',
  twoWeeksAgo: '2 minggu lalu',
  lastWeek: 'Minggu lalu',
  today: 'Hari ini',
  aiInsights: 'Cerapan AI Tupai',
  keyStrengths: 'Kekuatan Utama',
  areasToFocus: 'Bidang untuk Fokus',
  recommendation: 'Cadangan',
  assignedTo: 'Diberi kepada {studentName} · {date}',

  sampleReportTitle1: 'Minggu cemerlang dalam Pecahan',
  sampleReportTitle2: 'Peratus perlu perhatian',
  sampleReportTitle3: 'Kemajuan mantap dalam Nisbah',
  sampleReportTitle4: 'Kembali ke rutin',
  sampleReportTitle5: 'Minggu pertama latihan',
  sampleReportOverview:
    '{childName} berlatih 5 daripada 7 hari dan menjawab 78% soalan dengan betul. Pecahan kini bab terkuatnya. Peratus masih mengelirukannya, terutamanya soalan tentang perubahan peratus.',
  sampleReportStrength1: 'Pecahan: 22 daripada 24 betul minggu ini, bab terbaiknya setakat ini.',
  sampleReportStrength2: 'Berlatih 5 daripada 7 hari, satu tabiat yang konsisten.',
  sampleReportImprovement1:
    'Peratus: 9 daripada 16 betul. Dia keliru antara "peratus daripada" dengan "perubahan peratus".',
} as const satisfies Messages['hub'];
